import axios from 'axios';
import store from '../store';

// eslint-disable-next-line no-undef
const api = axios.create({ baseURL: process.env.VUE_APP_API_URL });

// Attach token dynamically before each request
api.interceptors.request.use(config => {
  const { token } = store.state;
  if (token) {
    // eslint-disable-next-line no-param-reassign
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default api;
